import type JCE from '@chesscom/js-chess-engine';
import type { Game } from 'chessboard/model/game/types';
import type { VariationProcessingOptions } from './move-list-to-flat-tree';
import type { MoveListComponent } from '../config/types';
import { getCommentsForNode } from './node-line-utils';

/**
 * Returns a line with all its variations inlined recursively.
 */
export function getLineWithVariationsInlined(
  line: Game.Move.Node[],
  lines: JCE.Line[],
  options: VariationProcessingOptions = {},
): MoveListComponent.MoveListNode[] {
  const moveListNodes: MoveListComponent.MoveListNode[] = [];

  line.forEach((node, i) => {
    const { beforeComment, afterComment } = getCommentsForNode(
      node,
      options.initComment,
      options.ignoreComments,
    );
    const moveListNode: MoveListComponent.MoveListNode = {
      node,
      beforeComment,
      afterComment,
    };

    const isFirstNodeWithIgnoredVariations = i === 0 && options.ignoreFirstNodeVariations;

    if (node.lines && !isFirstNodeWithIgnoredVariations) {
      moveListNode.inlineVariations = [];

      node.lines.forEach((variationLineIndex) => {
        const inlineVariation = getLineWithVariationsInlined(lines[variationLineIndex], lines, {
          initComment: lines[variationLineIndex].initComment,
          ignoreComments: options.ignoreComments,
        });
        moveListNode.inlineVariations?.push(inlineVariation);
      });
    }

    moveListNodes.push(moveListNode);
  });

  return moveListNodes;
}
